import React from 'react';
import 'styles/pages/Table.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function Table({ children, className = '' }: Props): JSX.Element {
  return (
    <div className={`table-responsive ${className}`}>
      <table className="app-table">{children}</table>
    </div>
  );
}
